function changeQuantity(){
  let input = $(this);

  if ($(this).data("max")){
    $(this).siblings('button.up').click(function(e){addMax(e, input)});
  } else {
    $(this).siblings('button.up').click(function(e){add(e, input)});
  }

  $(this).siblings('button.down').click(function(e){subtract(e, input)});
}

function add(event, input){
  event.preventDefault();
  let value = parseInt(input.val()),
      new_value = value + 1;

  input.val(new_value).trigger('change');
}

function addMax(event, input){
  event.preventDefault();
  let value = parseInt(input.val())
  let max = Math.max(input.data("max"), 1);
  if(value < max){
    let new_value = value + 1
    input.val(new_value).trigger('change');
  } else {
    input.val(max).trigger('change');
  }
}

function subtract(event, input){
  event.preventDefault()
  let value = parseInt(input.val())
  if(value > 0){
    let new_value = value - 1
    input.val(new_value).trigger('change');
  } else {
    input.val(0).trigger('change');
  }
}

const init = () => {
  let quantityInputs = $('.quantity')
  quantityInputs.each(changeQuantity)

  $('.show_giftnote').click(function(){
    if ($(this)[0].checked) {
      $('.show_giftnote').each(function(){ $(this)[0].checked = true })
      $('.CartNote').slideDown()
      $('#CartNote').slideDown()
    }else {
      $('.show_giftnote').each(function(){$(this)[0].checked = false })
      $('.CartNote').slideUp()
      $('#CartNote').slideUp()
    }
  });

  $('[data-extra-pouches-atc]').click(function(){
    $(this).addClass("hidden");
    $(this).siblings('[data-extra-pouches-qty]').removeClass("hidden");
  });

}

export default init
